import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// LIBS
import API from "../../api";
import {
  fioFromObject,
  getFilialNameFromObject
} from "../../lib/helpers/strings";
import {
  getRoleNameFromObject,
  getRoleStyleFromObject,
  getDocsType,
  getDocsNumberFormatted
} from "../../lib/helpers/users";
import { getDateFormat } from "../../lib/helpers/dates";

// UI
import { TelPhones } from "@malond/ui-phone";
import {
  Alerts,
  P,
  Header,
  HeaderPage,
  LinkOrText,
  Button,
  Box,
  Row,
  Col
} from "../../ui";

class UserOnePage extends Component {
  state = {
    titleHeader: "Пользователь",
    user: {
      role_id: {},
      filial_id: {},
      power_of_attorney: { number_document: "", date_give: "" }
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const user = await API.users.getOne(id);
    if (user && user._id) {
      let titleHeader = `${user.username} - ${this.state.titleHeader}`;

      this.setState({ user, titleHeader });
    } else {
      Alerts.error("Пользователь не найден");
    }
  }

  render() {
    const { id } = this.props.match.params;
    const { user } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          preBeforeTitle={this.state.titleHeader}
          title={fioFromObject(user)}
          postSubTitle={user.username}
          back={this.props.history.goBack}
        />

        <Box>
          <Row withMain={true}>
            <Col padding="no" main={true}>
              <Header size={2} margin="no-top">
                Информация
              </Header>
            </Col>
            <Col padding="no" normal={true}>
              <Button size="s" type="as" as={Link} to={`/users/${id}/edit`}>
                Изменить информацию
              </Button>
            </Col>
          </Row>

          <Row>
            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Главное
              </Header>

              <Header size={6} margin="no-bottom">
                ФИО:
              </Header>
              <P slim>{fioFromObject(user)}</P>

              <Header size={6} margin="no-bottom">
                Филиал:
              </Header>
              <LinkOrText
                toBeforeId="/filials/"
                id={user.filial_id && user.filial_id._id}
                textAsP={true}
                propsTextP={{ slim: true }}
              >
                {getFilialNameFromObject(user.filial_id)}
              </LinkOrText>

              <Header size={6} margin="no-bottom">
                Роль:
              </Header>
              <span
                className={`label size-small label-${getRoleStyleFromObject(
                  user.role_id
                )}`}
              >
                {getRoleNameFromObject(user.role_id)}
              </span>

              <Header size={6} margin="no-bottom">
                Email:
              </Header>
              <P slim>{user.email || "Не указан"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Документ
              </Header>

              <Header size={6} margin="no-bottom">
                ИИН:
              </Header>
              <P slim>{getDocsNumberFormatted(user.iin)}</P>

              <Header size={6} margin="no-bottom">
                Вид документа:
              </Header>
              <P slim>{getDocsType(user.docs)}</P>

              <Header size={6} margin="no-bottom">
                Номер документа:
              </Header>
              <P slim>{getDocsNumberFormatted(user.docs_number)}</P>

              <Header size={6} margin="no-bottom">
                Кем выдан:
              </Header>
              <P slim>{user.docs_give_from || "Не указано"}</P>

              <Header size={6} margin="no-bottom">
                Дата выдачи:
              </Header>
              <P slim>{user.docs_give_date || "Не указана"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Прочее
              </Header>

              <Header size={6} margin="no-bottom">
                Телефон:
              </Header>
              <P slim>
                <TelPhones sizeNormal={true}>{user.tel}</TelPhones>
              </P>

              <Header size={6} margin="no-bottom">
                Адрес:
              </Header>
              <P slim>{user.address || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Доверенность:
              </Header>
              <P slim>
                №
                {(user.power_of_attorney &&
                  user.power_of_attorney.number_document) ||
                  "-"}{" "}
                от{" "}
                {(user.power_of_attorney && user.power_of_attorney.date_give) ||
                  "-"}
              </P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Изменения
              </Header>

              <Header size={6} margin="no-bottom">
                Дата создания:
              </Header>
              <P slim>{getDateFormat(user.created_at)}</P>

              <Header size={6} margin="no-bottom">
                Дата обновления:
              </Header>
              <P slim>{getDateFormat(user.updated_at)}</P>
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(UserOnePage));
